import { render, staticRenderFns } from "./BaseUpload.vue?vue&type=template&id=dd56cbf4&scoped=true"
import script from "./BaseUpload.vue?vue&type=script&lang=ts"
export * from "./BaseUpload.vue?vue&type=script&lang=ts"
import style0 from "./BaseUpload.vue?vue&type=style&index=0&id=dd56cbf4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd56cbf4",
  null
  
)

export default component.exports